import Control from "../../../../../common/Controls/Control";
import RCPROPrestationsInternationales from "./RCPROPrestationsInternationales";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPRODroit = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig, formState } =
    useRCPROQuestion({ company });

  const activityKey = "droit";

  return (
    <div>
      <Control
        label={inputsConfig.droitTypeExercice.label}
        type="btnList"
        name="droitTypeExercice"
        value={company.RCPRO.droitTypeExercice}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.droitTypeExercice.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      {company.RCPRO.droitTypeExercice == 5 && (
        <Control
          label={inputsConfig.droitAutreExercice.label}
          type="text"
          name="droitAutreExercice"
          value={company.RCPRO.droitAutreExercice}
          change={updateRcproData}
          error={errors}
          labelClassname="w-100"
          inputGroupStyle={{ width: "100%" }}
          onBlur={onBlur}
          required
        />
      )}
      <RCPROPrestationsInternationales
        company={company}
        activityKey={activityKey}
      />
    </div>
  );
};

export default RCPRODroit;
